var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"text-h5 text-center pa-5"},[_vm._v(" Sorry, this page hasn't been translated yet :( ")])])}]

export { render, staticRenderFns }